import { API_URL } from '../../../constants';
import _fetch from '../../_fetch';

export default function fetchBlogPost(options = {}) {
  return function withContext(context) {
    const url = `${API_URL}blog/posts/${options.slug}`;
    return _fetch(url, { withAuth: false }, { method: 'GET' })(context);
  };
}
